import React from 'react'

import { IconInline, Paragraph } from '@omnilert/components'

import dayjs from 'dayjs'

import { useIntl } from 'react-intl'

import useStyles from './updated-by.style'

const UpdatedBy = ({ item, index }) => {
  const classes = useStyles({ index })

  const intl = useIntl()

  const { timestamp, verb, user } = item

  const formatTime = timeData => {
    const timeFormat = dayjs(timeData.seconds * 1000).locale(intl.locale)
    const timeString = `${timeFormat.format('LT')}`
    const dateString = `on ${timeFormat.format('LL')}`
    return `${timeString} ${dateString}`
  }

  const updatedByString = `${user} ${verb} at ${formatTime(timestamp)}.`

  return (
    <div className={classes.wrapper}>
      <IconInline
        className={classes.icon}
        name='dot'
        rotate={0}
        size={8}
      />

      <Paragraph
        className={classes.text}
        color='var(--card--text__color)'
        size='cardSM'
      >{updatedByString}
      </Paragraph>
    </div>
  )
}

export default UpdatedBy
